import { Directive } from '@angular/core';
import { GridComponent } from '@progress/kendo-angular-grid';

// Kendo UI for Angular 19+ turns grid keyboard navigation on by default (navigable = ['table', 'pager', 'toolbar']);
// up to Kendo 18 it was off. Every grid in the app was written for the old default, so a grid without its own
// [navigable] binding keeps navigation off; a grid that binds [navigable] is not matched and keeps its value.
// Delete this directive to enable keyboard navigation app-wide.
@Directive({
    selector: 'kendo-grid:not([navigable])',
    standalone: false
})
export class GridNavigationDefaultDirective {
    constructor(grid: GridComponent) {
        grid.navigable = false;
    }
}
